



















































































import axios from "axios"
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class DropDown extends Vue {
    @Prop() private msg!: string;
    icon: any = [];
    DropdownValues: any = [];
    location: any = null;
    allLocations: any = [];
    uniqueArrLoc: any = [];
    uniqueArrDep: any = [];
    department: any = null;
    allDepartments: any = [];
    filterJobs: any = [];

    async mounted() {

        await this.listDropdownValues()
        this.uniqueArrLoc = [...new Set(this.DropdownValues.map((data: any) => data.categories.location))]
        this.uniqueArrDep = [...new Set(this.DropdownValues.map((data: any) => data.categories.department))]
    }


    async listDropdownValues() {
        await axios.get(`https://api.lever.co/v0/postings/rackspace`)
            .then(((jobRes) => {
                this.DropdownValues = jobRes.data;
            }))
    }

    async Submit() {
        let filterJobs
      if (this.location == null && this.department == null) filterJobs = this.DropdownValues;
        else filterJobs = (this.location !== null && this.department !== null) ? this.DropdownValues.filter((job: any) => job.categories.location === this.location && job.categories.department === this.department) : '' || (this.department !== '' && this.location === null) ? this.DropdownValues.filter((job: any) => job.categories.department === this.department) : '' || (this.location !== '' && this.department === null) ? this.DropdownValues.filter((job: any) => job.categories.location === this.location) : '';
        await this.$emit('filterJobs', filterJobs)
    }
}
